import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components/macro';
import { Input, Button } from '@deeptrue-frontend/ui';
import { Formik, Field as FormikField, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { FormatMessage } from 'components/IntlProvider/hooks/hooks';
import ErrorMessages from 'components/Fields/ErrorMessages';
import { useFormatMessage } from 'components/IntlProvider';

export interface ProfileValuesTypes {
  [key: string]: string;
}

export interface FormValues {
  new_email: string;
  confirm_email: string;
  actual_email: string;
  non_field_errors?: any;
}

interface Props {
  initialValues: FormValues;
  onSubmit: SubmitHandler;
}

export type SubmitHandler = (
  values: FormValues,
  helpers: FormikHelpers<FormValues>
) => void;

const StyledForm = styled.form`
  margin-top: 1rem;
  width: 100%;
`;

const getValidationSchema = (t: FormatMessage) =>
  Yup.object().shape<FormValues>({
    new_email: Yup.string()
      .required(t('errors.fields.required', 'Field is required'))
      .email(t('errors.fields.email.format', 'Invalid email format')),
    confirm_email: Yup.string()
      .email(t('errors.fields.email.format', 'Invalid email format'))
      .oneOf(
        [Yup.ref('new_email'), null],
        t('errors.fields.email.match', "Email addresses dont't match")
      )
      .required(t('errors.fields.required', 'Field is required')),
    actual_email: Yup.string(),
  });

const Email = ({ onSubmit, initialValues }: Props) => {
  const t = useFormatMessage();
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={getValidationSchema(t)}
    >
      {({ handleSubmit, isSubmitting, errors, touched }) => {
        const nonFieldErrors = errors.non_field_errors;

        return (
          <Grid item xs={12} md={7}>
            <StyledForm onSubmit={handleSubmit}>
              <FormikField
                as={Input}
                name="actual_email"
                label={t('forms.email.current', 'Current email')}
                disabled
              />
              <FormikField
                as={Input}
                name="new_email"
                label={t('forms.email.new', 'New email')}
                hasError={touched.new_email && errors.new_email}
                helperText={touched.new_email && errors.new_email}
              />
              <FormikField
                as={Input}
                name="confirm_email"
                label={t('forms.email.confirm', 'Confirm email')}
                hasError={touched.confirm_email && errors.confirm_email}
                helperText={touched.confirm_email && errors.confirm_email}
              />
              {nonFieldErrors && <ErrorMessages errors={nonFieldErrors} />}
              <Button
                mt="2rem"
                width="100%"
                disabled={isSubmitting}
                isLoading={isSubmitting}
                type="submit"
              >
                {t('forms.email.update', 'Update Email')}
              </Button>
            </StyledForm>
          </Grid>
        );
      }}
    </Formik>
  );
};

export default Email;
